import React from 'react';
import { PartyAvatar } from '../PartyAvatar';
import styles from './PrimaryNavigation.module.scss';
import { HelpDropdown, ProfileDropdown } from './components';
import {
  Link,
  Button,
  Icon,
  IconList,
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from 'components/core';
import { SearchBar, searchStudies } from 'components/shared/SearchBar';
import CovidenceLogo from 'assets/images/logos/covidence-full-white.svg';
import { Inline } from 'components/layout';

export type Plan = {
  name: string;
  expired?: boolean;
};

export type Organization = {
  id: string;
  name: string;
  isAdmin: boolean;
};

export type Reviewer = {
  account: { plan: Plan };
  organizations?: Organization[];
  first_name?: string;
  last_name?: string;
  email?: string;
  admin?: boolean;
  can_proxy?: boolean;
};
export type PrimaryNavigationProps = {
  myDiscussionPath?: string;
  logoPath?: string;
  reviewPath?: string;
  reviewTitle?: string;
  reviewer?: Reviewer;
  searchPath?: string;
};

const PrimaryNavigation = ({
  myDiscussionPath,
  logoPath = '/reviews',
  searchPath,
  reviewPath,
  reviewTitle,
  reviewer = { account: { plan: { name: '', expired: false } } },
}: PrimaryNavigationProps) => {
  return (
    <nav className={styles.PrimaryNavigation} id="react-ds-primary-nav">
      <Inline
        spacing={4}
        alignX="spaceBetween"
        className={styles.PrimaryNavigation_content}
      >
        <Link className={styles.PrimaryNavigation_logo} to={logoPath}>
          <img
            src={CovidenceLogo}
            alt="Covidence Logo"
            height="24"
            width="127"
          />
        </Link>

        <Inline
          spacing={4}
          alignX="spaceBetween"
          className={styles.PrimaryNavigation_left}
          shouldWrap={false}
        >
          {reviewPath && (
            <Button
              type="brand"
              size="sm"
              className={styles.PrimaryNavigation_reviewButton}
              to={reviewPath}
              isNaked
              data-testid={'primary-navigation'}
            >
              {reviewTitle}
            </Button>
          )}
          {searchPath && (
            <SearchBar
              onSearch={(term) => searchStudies(term, searchPath)}
              className={styles.PrimaryNavigation_searchBar}
            />
          )}
        </Inline>

        <Inline
          spacing={2}
          alignX="center"
          className={styles.PrimaryNavigation_right}
          shouldWrap={false}
        >
          {myDiscussionPath && (
            <Tooltip>
              <TooltipTrigger>
                <Button
                  to={myDiscussionPath}
                  iconOnly
                  size="md"
                  type="brand"
                  className={styles.PrimaryNavigation_iconButton}
                  aria-label="Discussions"
                  data-testid="discussionsLink"
                  data-name="my-discussions"
                >
                  <Icon icon={IconList.light.faMessage} />
                </Button>
              </TooltipTrigger>
              <TooltipContent>Discussions</TooltipContent>
            </Tooltip>
          )}
          <HelpDropdown>
            <Tooltip placement="bottom">
              <TooltipTrigger>
                <span>
                  <Icon icon={IconList.light.faQuestionCircle} />
                </span>
              </TooltipTrigger>
              <TooltipContent>Help</TooltipContent>
            </Tooltip>
          </HelpDropdown>
          <ProfileDropdown reviewer={reviewer}>
            <Tooltip placement="bottom">
              <TooltipTrigger>
                <PartyAvatar
                  name={`${reviewer.first_name} ${reviewer.last_name}`}
                  variant="user"
                  size="sm"
                />
              </TooltipTrigger>
              <TooltipContent>{`${reviewer.first_name} ${reviewer.last_name}`}</TooltipContent>
            </Tooltip>
          </ProfileDropdown>
        </Inline>
      </Inline>
    </nav>
  );
};

export default PrimaryNavigation;
